module.exports = __webpack_public_path__ + "img/ranking-bg-3.56c8c81.png";